// extracted by mini-css-extract-plugin
module.exports = {"showColumnsIcon":"Table_showColumnsIcon__35Sim","columnHeaderWithIcon":"Table_columnHeaderWithIcon__2hZi5"};